import workplans from '../../views/screens/Workplans/sidebarLayout';
import routes from '../../views/screens/Routes/sidebarLayout';
import optimizations from '../../views/screens/Optimizations/sidebarLayout';
import vehicleFuel from './vehicleFuel';
import orders from '../../views/screens/Orders/sidebarLayout';
import hubs from '../../views/screens/Hubs/sidebarLayout';

import vehicleMaintenance from './vehicleMaintenance';

export default [
  {
    header: 'sidebar.logistics',
    iconName: 'Share2',
    badgeText: 'common.premium',
    children: [
      ...orders,
      ...routes,
      ...workplans,
      ...vehicleFuel,
      ...vehicleMaintenance,
      ...optimizations,
      ...hubs
    ] //Only to check permission in children inside
  },
  ...orders,
  ...routes,
  ...workplans,
  ...vehicleMaintenance,
  ...vehicleFuel,
  ...optimizations,
  ...hubs
];
